// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__uk+-m","items":"styles_items__A7kYw","slide-in":"styles_slide-in__+RwRZ","lines":"styles_lines__y+cb+","clip-path":"styles_clip-path__7qUsT"};